module.exports = __webpack_public_path__ + "static/media/1.ae3b33ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/infocast/1.jpg
// module id = 477
// module chunks = 0